import { initObservability as init, globalObservability } from '@opendoor/observability';

import {
  GOOGLE_ANALYTICS_KEY,
  DATADOG_RUM_APPLICATION_ID,
  DATADOG_RUM_APPLICATION_CLIENT_TOKEN,
  DEPLOY_ENV,
} from '../components/globals';

const RAVEN_URL = 'https://3414e8de867a4131a44598d29006eccc@sentry.io/1439728';

//observability
export const initObservability = () => {
  // make sure we only init observability client-side
  if (typeof window !== 'undefined' && !globalObservability) {
    init({
      eventTrackingCategory: 'cosmos',
      googleAnalyticsToken: GOOGLE_ANALYTICS_KEY,
      env: DEPLOY_ENV,
      sentry: {
        appName: 'cosmos',
        dsn: RAVEN_URL,
        maxBreadcrumbs: 50,
        attachStacktrace: true,
        // Only allow errors from first-party sources, to reduce sentry spam
        allowUrls: ['simplersell.com', 'opendoor.com'],
        // observability package has default ignore errors set by default
        // https://github.com/opendoor-labs/code/blob/master/js/packages/observability/src/internal/sentry.ts#L138
      },
      datadog: {
        service: 'cosmos',
        applicationId: DATADOG_RUM_APPLICATION_ID,
        clientToken: DATADOG_RUM_APPLICATION_CLIENT_TOKEN,
        sampleRate: 50,
        trackInteractions: true,
        silentMultipleInit: true,
        trackSessionAcrossSubdomains: true,
        // Please be careful when adding tracing origins.
        // If a server is not prepared for the new Datadog headers, then it may fail with CORS errors.
        // Relevant postmortem: https://docs.google.com/document/d/1O9eWUdXZJOS4Oha2v_dtPfjO34IU3KEDpNqjk3AtXdk/edit
        allowedTracingOrigins: [/https:\/\/.*\.simplersell\.com/, /https:\/\/.*\.opendoor\.com/],
      },
    });
  }
};
